// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import ahatutorial from './store/ahatutorial';
import general from './store/general';
import controls from './store/controls';
//import tenancystore from './store/tenancystore';
import VuexPersistence from 'vuex-persist';
import Vuetify from 'vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';
import { sharedReactorWebsocket as ws } from 'reactor-js-core/dist/reactor';
import { sharedReactorAuthentication as auth} from 'reactor-js-core/dist/authentication';
import Configuration from './configuration';
import log, { LoggerVuePlugin } from 'reactor-js-core/dist/log';
import StoreFactory from './store';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import locales from '@alienfast/i18next-loader!../../ReactorLanguage/src/locales/index.js';
//import locales from '@alienfast/i18next-loader!../static/locales/index.js';
//import localesVuetify from '@alienfast/i18next-loader!../static/locales-vuetify/index.js';
import zhHant from 'vuetify/lib/locale/zh-Hant'
import ja from 'vuetify/lib/locale/ja'
import es from 'vuetify/lib/locale/es'
import de from 'vuetify/lib/locale/de'
import fr from 'vuetify/lib/locale/fr'
import FormCard from '@/components/ui/FormCard';
import FormHeader from '@/components/ui/FormHeader';
import FormTextField from '@/components/ui/FormTextField';
import FormSubmitButton from '@/components/ui/FormSubmitButton';
import OutlineButton from '@/components/ui/OutlineButton';
import OrBorder from '@/components/ui/OrBorder';
import CommonDialog from '@/components/ui/CommonDialog';
import CheckboxGroup from '@/components/ui/CheckboxGroup';
import InlineEditField from '@/components/ui/InlineEditField';
import InlineEditArea from '@/components/ui/InlineEditArea';
import StatefulCheckbox from '@/components/ui/StatefulCheckbox';
import LockedFeatureSwitch from '@/components/ui/LockedFeatureSwitch';
import 'animate.css/animate.min.css';
import proxydetection from './proxydetection.js';
import cssVars from 'css-vars-ponyfill';
import { persistentStorage } from 'reactor-js-core/dist/persistentstorage.js'
import moment from 'moment-timezone'
import sanitizeHtml from 'sanitize-html';
import utils from 'reactor-js-core/dist/utils.js';
import VueForceNextTick from 'vue-force-next-tick';

import VueKatex from 'vue-katex';
import 'katex/dist/katex.min.css';
import linkify from 'vue-linkify'

Vue.directive('linkified', linkify)

var configs = require('../config');

const defaultLang = 'en';
const env = process.env.NODE_ENV;
const config = env === 'development' ? configs.dev : configs.build;

Vue.use(LoggerVuePlugin);

log.info("Environment: " + env);

if (config.indexPage === "vevox-dashboard" && isInternetExplorer()) {
  // show browser not supported message for Internet Explorer
  // this might look a bit hacky but the page might not load correctly and thus we cannot rely on Vue functionality or Vuetify styling
  var outer = document.createElement("div");
  outer.setAttribute("style", "width:100%; padding-top:80px; font-size:22px; font-weigth:400; line-height:1.5; text-align:center;")
  outer.setAttribute("class", "browser-not-supported-message");
  var textbox = document.createElement("div");
  textbox.innerHTML =
    "<h3>Support for Internet Explorer</h3><br/>" +
    "<p>We have detected you are still using Internet Explorer which we no longer support.</p>" +
    "<p style='padding-top: 12px;'>We recommend using Vevox in a different browser such as Chrome, Edge, Firefox or Safari.</p>";
  textbox.setAttribute("style", "max-width: 80%; display:inline-block; border:4px solid #ddd; margin:auto; padding:30px;");
  outer.appendChild(textbox);
  document.body.appendChild(outer);

  // create style to hide vue app in case it manages to start
  var style = document.createElement("style");
  style.innerHTML = '#app { display: none; }';
  document.head.appendChild(style);
}

function isInternetExplorer() {
  return /Trident\/|MSIE/.test(window.navigator.userAgent);
}

Vue.component("r-form-card", FormCard);
Vue.component("r-form-header", FormHeader);
Vue.component("r-form-text-field", FormTextField);
Vue.component("r-form-submit-button", FormSubmitButton);
Vue.component("r-outline-button", OutlineButton);
Vue.component("r-or-border", OrBorder);
Vue.component("r-dialog", CommonDialog);
Vue.component("r-checkbox-group", CheckboxGroup);
Vue.component("r-inline-edit-field", InlineEditField);
Vue.component("r-inline-edit-area", InlineEditArea);
Vue.component("r-checkbox", StatefulCheckbox);
Vue.component("r-locked-feature-switch", LockedFeatureSwitch);

Vue.config.productionTip = false;
Vue.use(Configuration, config);
Vue.use(Vuex);
Vue.use(VueKatex, {
  globalOptions: {
    delimiters: [
      {left: '$$', right: '$$', display: false}
    ],
  }
});
/*Vue.directive('click-outside', {
  priority: 700,
  bind () {
    let self  = this
    this.event = function (event) {
    	console.log('emitting event')
    	self.vm.$emit(self.expression,event)
 	  }
    this.el.addEventListener('click', this.stopProp)
    document.body.addEventListener('click',this.event)
  },

  unbind() {
  	console.log('unbind')
    this.el.removeEventListener('click', this.stopProp)
    document.body.removeEventListener('click',this.event)
  },
  stopProp(event) {event.stopPropagation() }
})
*/

Vue.use(VueI18Next);
Vue.use(VueForceNextTick);


export default function(options) {
  options.translations = process.env.TRANSLATIONS;

  ws.setTranslationService(i18next);
  if (options.connectWebsocket == null || options.connectWebsocket == true) {
    log.info("Connecting to " + config.httpapiEndpoint);
    ws.connect(config.httpapiEndpoint);
  }

  if (!options.theme) {
    options.theme = {
      primary: {
        defaultBase: '#00838D', //should be the same as base, used when resetting a custom primary color back to the default
        base: '#00838D',
        lighten1: '#78C7C9',
        lighten2: '#BFE0E2',
        lighten3: '#BFE0E2',
        lighten4: '#EAF5F6',
        lighten5: '#EAF5F6',
      },
      secondary: '#005276',
      accent: '#C25002',
      error: '#B30E0A'
    };
  }
  if (!options.themeDark) {
    options.themeDark = {}
  }

  if (!options.imageBaseFolder) {
    options.imageBaseFolder = '/static/images/';
  }

  if (!options.settings) {
    options.settings = {}
  }

  const vuetifyOptions = {
    icons: {
      iconfont: options.icons ? options.icons :'md',
      values: options.iconvalues
    },
    lang: {
      locales: {zhHant, ja, es, de, fr},/*localesVuetify,*/
      current: defaultLang
    },
    theme: {
      options: {
        customProperties: true,
      },
      themes: {
        light: options.theme,
        dark: options.themeDark
      },
      dark: options.defaultDark ? true : false,
    }
  }

  var defaultAllowedTags = [ //copied from ng-sanitize as we were using those default settings before
    "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
    "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
    "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
    "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
    "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
    "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
    "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr"
  ]
  let defaultAllowedAttributes= {
    'h1': ['style'],
    'h2': ['style'],
    'h3': ['style'],
    'h4': ['style'],
    'h5': ['style'],
    'h6': ['style'],
    'span': ['style'],
    'strong': ['style'],
    'em': ['style'],
    'u': ['style'],
    'a': [ 'style', 'href', 'rel', 'target' ],
    'ul': [ 'class' ],
    'li': [ 'class' ],
  };
  let defaultAllowedStyles= {
    '*': {
      'color': [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
    },
  };
  Vue.prototype.sanitizeHtml = function(message, allowedTags, allowedAttributes, allowedStyles) {
    return sanitizeHtml(message, {
      'allowedTags': allowedTags ? allowedTags : defaultAllowedTags,
      'allowedAttributes': allowedAttributes ? allowedAttributes : '',
      'allowedStyles': allowedStyles ? allowedStyles : '',
      transformTags: {
        'a': sanitizeHtml.simpleTransform('a', {target: '_blank'}),
      }
    });
  }
  Vue.prototype.sanitizeWysiwygHtml = function(message, allowedTags, allowedAttributes, allowedStyles) {
    return sanitizeHtml(message, {
      'allowVulnerableTags': true, //allow style on tags for colours
      'allowedTags': allowedTags ? allowedTags : defaultAllowedTags,
      'allowedAttributes': allowedAttributes ? allowedAttributes : defaultAllowedAttributes,
      'allowedStyles': allowedStyles ? allowedStyles : defaultAllowedStyles
    });
  }

  Vue.use(Vuetify);

  // Create VueI18n instance with options
  if (!options.i18nextDefaultNameSpace) {
    options.i18nextDefaultNameSpace = 'vevox';
  }
  if (options.i18nextFallbackNameSpace) {
    i18next.init({
      lng: defaultLang, // set locale
      fallbackLng: 'en',
      defaultNS: options.i18nextDefaultNameSpace,
      fallbackNS: options.i18nextFallbackNameSpace,
      resources: locales,
    });
    // add custom translations
    // the i18nextCustomTranslations object maps language -> namespace -> translation, example:
    //    "en": {"namespace": {"key1": "value1", "key2": "value2"}}
    if (options.i18nextCustomTranslations) {
      for (const [lang, namespaces] of Object.entries(options.i18nextCustomTranslations)) {
        for (const [namespace, translation] of Object.entries(namespaces)) {
          i18next.addResourceBundle(lang, namespace, translation, true, true);
        }
      }
    }
  }
  else {
    i18next.init({
      lng: defaultLang, // set locale
      fallbackLng: 'en',
      ns: [options.i18nextDefaultNameSpace, options.i18nextDefaultNameSpace + '_user_roles', 'user_roles', 'admin'],
      defaultNS: [options.i18nextDefaultNameSpace, options.i18nextDefaultNameSpace + '_user_roles'],
      fallbackNS: ['user_roles', 'admin'],
      resources: locales,
    });
  }
  const i18n = new VueI18Next(i18next);

  if (!options.store) {
    let plugins = [];
    let mutations = {};
    if (persistentStorage.enabled()) {
      const vuexPersist = new VuexPersistence({
        strictMode: env === 'development', // This **MUST** be set to true for dev env
        reducer: (state) => (
          {
            ahatutorial: state.ahatutorial,
            generalpersisted: state.generalpersisted
          }
        ),
        storage: window.localStorage
      });

      plugins.push(vuexPersist.plugin);
      mutations["RESTORE_MUTATION"] = vuexPersist.RESTORE_MUTATION // this mutation **MUST** be named "RESTORE_MUTATION"
    }

    const defaultStore = StoreFactory.createStore(
      {
        ahatutorial,
        general,
        generalpersisted: general,
        controls
      },
      plugins,
      mutations
    );
    options.store = defaultStore;
  }
  if (options.store != null) {
    options.store.watch(
      () => options.store.getters['errors/getErrors'], list => {
        if (list.length > 0) {
          console.log(JSON.stringify(list[list.length - 1]));
        }
      }
    );
    ws.setVuexStore(options.store);
  }

  //global navigation guard (from https://router.vuejs.org/guide/advanced/meta.html)
  //this takes care of redirecting to login page if you are not at all logged in (no stored session ID)
  //session timeout is handled separately for the case when you do have a stored session ID but it's invalid
  if (options.router) {
    options.router.beforeEach((to, from, next) => {
      if (to.matched.some(record => record.meta.requiredPermission)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!auth.isAuthenticated() && !auth.getAuthPermissions().includes(to.meta.requiredPermission)) {
          next({
            name: 'LoginForm',
            query: { redirectHash: to.fullPath }
          })
        } else if (typeof to.meta.requiredPermission === 'undefined' || auth.getAuthPermissions().indexOf(to.meta.requiredPermission) > -1) {
          next();
        } else {
          //if user does not have required permisson, go to meetinglist
          var perms = auth.getAuthPermissions();
          if (perms == null || perms.length == 0) {
            //permissions might not have been loaded yet
            //TODO might need to implement redirect away from page after permissions are loaded
            next();
          }
          else {
            next({
              path: '/'
            })
          }
        }
      } else {
        next() // make sure to always call next()!
      }
    });
  } else {
    if (!auth.isAuthenticated()) {
      var href = window.location.href;
      if (window.location.hash.replace(/\//g, "").length > 1) {
        href = href.substring(0, href.indexOf(window.location.hash));
      } else {
        href = href.substring(0, href.lastIndexOf("/"));
      }
      window.location.href = href;
    }
  }

  /* eslint-disable no-new */
  new Vue({
    i18n,
    el: '#app',
    store: options.store,  // inject the store instance to all child components
    router: options.router,
    vuetify: new Vuetify(vuetifyOptions),
    data: {
      sessionExpiredShowing: false,
      pageLoading: true,
      authUserId: null,
      proxyDetectionInstance: null,
      imageBaseFolder: null,
      settings: null,
      onLine: navigator.onLine,
      translations: 'en',
      overrideLanguage: null,
      singleMeetingMode: false,   // hides top bar and side menu to prevent user of reaching meeting id entry screen
      webexIsShared: false,
      webexLastShareURL: null
    },
    components: { vuePage: options.vuePage },
    render: createElement => createElement(options.vuePage, {ref: 'app'}),
    mounted() {
      this.imageBaseFolder = options.imageBaseFolder;
      this.proxyDetectionInstance = proxydetection(this);
      this.settings = options.settings;
      if (Array.isArray(this.settings.translations) && this.settings.translations.length > 0) {
        this.translations = this.settings.translations;
      }

      this.updateTitle();

      var page_needs_authentication = () => {
        if (window.location.hash.replace(/\//g, "").length > 1 && window.location.hash.indexOf("redirectHash") == -1) {
          if (this.$route != null && this.$route.meta != null && this.$route.meta.requiredPermission) {
            return true;
          }
        }
        return false;
      }

      this.checkThemeParameter();

      auth.setExpiredCallback(() => {
        if (page_needs_authentication()) {
          if (!this.sessionExpiredShowing) {
            this.sessionExpiredShowing = true;
            this.alert(this.$t('session_expired'), () => {
              this.sessionExpiredShowing = false;
              var href = window.location.href;
              href = href.substring(0, href.indexOf(window.location.hash));
              window.location.href = href + "#?redirectHash=" + encodeURIComponent(window.location.hash.substring(1));
              window.location.reload();
            });
          }
        }
        else {
          //make sure page loads correctly after session has been purged
          window.location.reload();
        }
      });
      if (options.loadedCallback) {
        auth.setLoginCallback(() => {
          options.loadedCallback(this);
        });
      }
      if (options.publicAccessKey) {
        if (auth.getAuthSessionId() != null) {
          auth.setupPublicAccess(options.publicAccessKey);
          auth.resumeSession(this.loadedCallback);
        } else {
          auth.setupPublicAccess(options.publicAccessKey, this.loadedCallback);
        }
      } else {
        auth.resumeSession(this.loadedCallback);
      }
      this.authUserId = auth.getAuthUserId();

      // enable css custom properties ponyfill for Internet Explorer
      if (this.isInternetExplorer()) {
        cssVars({
          rootElement   : document,
          shadowDOM     : false,
          include       : 'link[rel=stylesheet],style',
          exclude       : '',
          variables     : {},
          onlyLegacy    : true,
          preserveStatic: true,
          preserveVars  : false,
          silent        : false,
          updateDOM     : true,
          updateURLs    : true,
          watch         : false,
        });
      }

      let language = this.getStoredLanguage();
      const lang_param = utils.getHashOrQueryParameter(this, 'lang');
      if (lang_param) {
        // lang paramater in url will override stored language
        language = lang_param.toLowerCase();
        // we use a mixed case identifier for chinese for some reason while for other languages we use lower case with underscore separator
        if (language === 'zhhans' || language === 'zh_hans') language = 'zhHans';
        if (language === 'zhhant' || language === 'zh_hant') language = 'zhHant';
      }
      if (this.getSetting('autodetect_language') && language == null) {
        language = this.setAutodetectLanguage();
      }
      if (!language) language = 'en';
      this.changeLanguage(language);
    },
    beforeDestroy() {
      this.proxyDetectionInstance.shutdown();
    },
    watch: {
      '$route' (to, from) {
        if (options.routeChangedCallback) {
          options.routeChangedCallback(this);
        }
        this.authUserId = auth.getAuthUserId();
        this.checkThemeParameter();
        this.updateTitle();
      },
    },
    methods: {
      updateTitle() {
        var title_key = "page_title_default";
        if (this.$route.meta.title != null) {
          title_key = this.$route.meta.title;
        }
        if (this.$i18n.i18next.exists(title_key)) {
          var page_title = this.$t(title_key);
          if (this.$i18n.i18next.exists('page_title_prefix')) {
            page_title = this.$t('page_title_prefix') + " - " + page_title;
          }
          document.title = page_title;
        }
        else {
          var tenancy = auth.getAuthTenancy();
          if (tenancy != null) {
            document.title = this.$t('page_title_prefix') + " - " + tenancy.tenancyName;
          }
        }
      },
      getSetting(name) {
        if (this.settings && this.settings.hasOwnProperty(name)) {
          return this.settings[name];
        }
        return null;
      },
      getImageBaseFolder() {
        return this.imageBaseFolder;
      },
      getBrandedInstanceSettings() {
        return options.brandedInstanceSettings;
      },
      getAppLogoUrl() {
        let bi = options.brandedInstanceSettings;
        if (bi == null) {
          if (this.$vuetify.theme.dark) return 'static/images/presentation-view/vevox-logo-light.svg'
          return 'static/images/vevox-logo.svg';
        }
        else {
          if (bi.logoUrl) {
            return bi.logoUrl;
          }
          else {
            return '';
          }
        }
      },
      loadedCallback() {
        this.authUserId = auth.getAuthUserId();
        if (options.loadedCallback) {
          options.loadedCallback(this).then(response => {
            this.pageLoading = false;
          }, failure => {
            console.log("Failed to load page"); //TODO: Improve error handling
            this.pageLoading = false;
          });
        } else {
          this.pageLoading = false;
        }
      },
      checkThemeParameter() {
        // set dark theme if enabled by url parameter
        const theme_param = utils.getHashOrQueryParameter(this, 'theme');
        if (theme_param) {
          this.$vuetify.theme.dark = theme_param === 'dark';
        }
      },
      confirm(message, callback) {
        if (this.$refs.app.confirm != null) {
          return this.$refs.app.confirm(message, callback);
        }
        else {
          //fallback if the page did not define a confirm UI
          if (confirm(message)) {
            callback(true);
          }
          else {
            callback(false);
          }
        }
      },
      confirmPromise(message) {
        return new Promise((resolve_func, reject_func) => {
          this.confirm(message, confirmed => {
            if (confirmed) {
              resolve_func(true);
            }
            else {
              reject_func("ConfirmRejectedByUser");
            }
          });
        });
      },
      alert(message, callback) {
        if (this.$refs.app.alert != null) {
          return this.$refs.app.alert(message, callback);
        }
        else {
          //fallback if the page did not define an alert UI
          alert(message);
          callback();
        }
      },
      getCurrentLanguage() {
        let lang = this.getStoredLanguage();
        if (!lang) return 'en';
        return lang;
      },
      getStoredLanguage() {
        return persistentStorage.get("dashboard_language");
      },
      getEnabledLanguages() {
        return this.translations;
      },
      changeLanguage(lang) {
        persistentStorage.set("dashboard_language", lang);
        this.$vuetify.lang.current = lang;
        if (this.overrideLanguage == null) {
          this.$i18n.i18next.changeLanguage(lang);
        } else {
          this.$i18n.i18next.changeLanguage(this.overrideLanguage);
        }
        this.setLocale(lang);
        this.setRTL(lang)
      },
      setAutodetectLanguage() {
        let language_string = navigator.language || navigator.userLanguage || 'en';

        let condensed_language = language_string.replace('_', '').replace('-', '');
        let supported_language = this.supportedLanguage(condensed_language);

        if (!supported_language) {
          let language_part = language_string.split(/[_-]/)[0];
          supported_language = this.supportedLanguage(language_part);
        }

        if (supported_language) {
          return supported_language.code;
        }
        return 'en';
      },
      supportedLanguage(lng) {
        let resolved = lng;
        //set zhhant for all trad chinese
        if (resolved.toLowerCase() === 'zhtw' || resolved.toLowerCase() === 'zhhk') resolved = 'zhhant';

        return this.translations.find(translation => translation.code.toLowerCase() === resolved);
      },
      setLocale(lang) {
        if (lang === 'zhHant') {
          moment.locale('zh-tw');
        } else {
          moment.locale(lang);
        }
      },
      setRTL(lang) {
        if (lang === 'ar') {
          this.$vuetify.rtl = true;
        } else {
          this.$vuetify.rtl = false;
        }
      },
      setOverrideLanguage(lang) {
        this.overrideLanguage = lang;
        this.$i18n.i18next.changeLanguage(lang);
      },
      setCustomPrimaryColor(color) {
        options.theme.primary.base = color;
      },
      hasCustomPrimaryColor() {
        return options.theme.primary.base !== options.theme.primary.defaultBase;
      },
      resetCustomPrimaryColor() {
        options.theme.primary.base = options.theme.primary.defaultBase;
      },
      setCustomLogo(url) {
        options.settings.login_page_logo = url;
      },
      hasCustomLogo() {
        return options.settings.login_page_logo !== options.settings.default_login_page_logo;
      },
      resetCustomLogo() {
        options.settings.login_page_logo = options.settings.default_login_page_logo;
      },
      hasPermission(perm) {
        return auth.getAuthPermissions().indexOf(perm) != -1
      },
      getAuthPermissions() {
        return auth.getAuthPermissions();
      },
      getTenancy() {
        var t = auth.getAuthTenancy();
        if (t) {
          return t;
        }
        return {tenancyId: -1, appId: "", tenancyName: "", tenancyURL: ""};
      },
      getTenancyPromise() {
        return auth.tenancyPromise;
      },
      getUserName() {
        return auth.getAuthUserName();
      },
      getProfile() {
        return auth.getAuthProfile();
      },
      addError(message) {
        this.$store.dispatch({type: 'errors/add', message:message});
      },
      isSingleSession() {
        return config.singleSession;
      },
      getProjectType() {
        var project_type = this.$store.getters['general/getProjectType'];
        if (project_type) {
          return project_type;
        } else {
          return config.projectType;
        }
      },
      appId() {
        var app_id = this.$store.getters['general/appId'];
        if(app_id) {
          return app_id;
        } else if (config.appId == '') {
          return null;
        } else {
          return config.appId;
        }
      },
      getPublicAudienceDisplayUrl(tenancy) {
        const parts = tenancy.tenancyURL.split('.');
        const tenancy_name = parts[0];
        return config.audienceDisplayUrl.replace("{{tenancy_name}}", tenancy_name);
      },
      convertToReactorDashboardUrl(tenancy) {
        if (env === 'development') {
          return "http://" + tenancy.tenancyURL+":8082/";
        } else {
          //const parts = tenancy.tenancyURL.split('.');
          //const name = parts[0];
          //var url = "https://" + name + '.' + config.reactorDashboardDomain;
          var url = "https://" + tenancy.tenancyURL;
          if (!(url.endsWith('/') || url.endsWith('/index.html'))) {
            url += '/';
          }
          return url;
        }
      },
      getPlayDashboardUrl(include_protocol) {
        var protocol = "";
        if (env === 'development') {
          if (include_protocol) {
            protocol = "http:";
          }
          return protocol + "//" + this.getPlayDashboardHostName()+":9000";
        } else {
          if (include_protocol) {
            protocol = "https:";
          }
          return protocol + "//" + this.getPlayDashboardHostName();
        }
      },
      getPlayDashboardHostName() {
        if (env === 'development') {
          return config.playDashboardDomain;
        } else {
          const parts = window.location.hostname.split('.');
          const name = parts[0];
          return name + '.' + config.playDashboardDomain;
        }
      },
      getWebClientDomain() {
        return config.webClientDomain;
      },
      redirectToLogin() {
        if (this.$route.name === 'LoginForm') return;
        // redirect
        this.$router.replace({
          name: "LoginForm",
          query: this.$route.query
        })
      },
      mayRedirectTo(candidate) {
        var url = new URL(candidate);
        if (url.hostname.endsWith(config.reactorDashboardDomain)) return true;
        if (url.hostname.endsWith(config.playDashboardDomain)) return true;

        var allowed_urls = config.allowedRedirectUrls;
        var protocol_end = -1;
        if (typeof candidate == "undefined" || candidate == null) {
          return false;
        }
        if ((protocol_end = candidate.indexOf("//")) != -1) {
          candidate = candidate.substring(protocol_end+2);
        }
        for (var i=0; i<allowed_urls.length; i++) {
          if ((candidate.indexOf(allowed_urls[i]) === 0 || url.hostname.endsWith(allowed_urls[i])) && allowed_urls[i].length > 0) {
            return true;
          }
        }
        return false;
      },
      connectToRegion(region_url) {
        if (region_url != null && region_url != "" && this.mayRedirectTo(region_url)) {
          ws.connectToRegion(region_url);
        }
      },
      isInternetExplorer() {
        return /Trident\/|MSIE/.test(window.navigator.userAgent);
      },
      appElementStyles() {
        if (this.$store.state.general.customBackgroundStyles) {
          return this.$store.state.general.customBackgroundStyles;
        }
        else {
          return {
            //"background-image": "url('" + this.getDefaultBackgroundImageUrl() + "')"
            "background-color": "#FAFAFA"
          }
        }
      },
    }
  });
}

// fake Shadow DOM API polyfill for IE11 that does nothing
// Vuetify does some "instanceof ShadowRoot" checks that causes issues with IE11. The problem goes away by simply defining
// a window.ShadowRoot class. It could potentially break when updating Vuetify though
if (!('ShadowRoot' in window)) {
  log.info("This browser does not support Shadow DOM API, creating fake ShadowRoot");
  class ShadowRoot {
  }
  window.ShadowRoot = ShadowRoot;
}



// WEBPACK FOOTER //
// ./src/page.js